import { init } from '@sentry/react';
const initializeSentry = () => {
    if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
        init({
            dsn: process.env.SENTRY_DSN,
            environment: process.env.SENTRY_ENVIRONMENT,
        });
    }
};
export default initializeSentry;
